import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import {
  analyticsEvent$,
  canAnalyticsActivate,
} from '@helpers/engine/analytics';
import { analyticsBoundEventId } from '@helpers/engine/analytics.ui';
import { info } from '@helpers/engine/logging';
import { getOption } from '@helpers/state-options';
import { MetaService } from '@services/meta.service';
import gameanalytics from 'gameanalytics';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  private metaService = inject(MetaService);

  private analytics: typeof gameanalytics.GameAnalytics;

  init() {
    const canActivateAnalytics = canAnalyticsActivate();
    if (!canActivateAnalytics) {
      info('GameAnalytics', 'Not starting analytics; in an iframe.');
      return;
    }

    if (environment.gameanalytics.game && environment.gameanalytics.secret) {
      this.analytics = gameanalytics.GameAnalytics;
      this.analytics.configureBuild(
        `${environment.platform} ${this.metaService.versionString()}`,
      );
      this.analytics.initialize(
        environment.gameanalytics.game,
        environment.gameanalytics.secret,
      );

      info('GameAnalytics', 'Started listening for GA design events.');

      analyticsEvent$.subscribe(({ event, value }) => {
        this.sendDesignEvent(event, value ?? 1);
      });
    } else {
      info('GameAnalytics', 'Not starting GA. Missing game id and secret id.');
    }
  }

  sendDesignEvent(eventId: string, value: number = 0) {
    if (!getOption('analyticsEnabled')) return;

    this.analytics?.addDesignEvent(analyticsBoundEventId(eventId), value);
  }
}
